module.exports = __webpack_public_path__ + "static/media/Co occurring Disorders.9f7c0d6a.svg";